// library
import { FC } from "react";
import { Card, CardHeader, CardMedia, CardActionArea } from "@mui/material";
// type
import { Event } from "../types/event";
import { Feature } from "geojson";
import { Point } from "geojson";
// common
import Utils from "../common/utils";
import EventSchema from "../common/event-schema";

const MapEventCard: FC<any> = (props: { config: any, feature: Feature, clickCard: any, currentFeature: Feature }) => {
  const { config, feature, clickCard, currentFeature } = props;

  const event = feature.properties as Event;

  const TITLE_MAX_LENGTH = 10;
  const SUB_TITLE_MAX_LENGTH = 14;

  // GoogleMapを表示
  const geometry = currentFeature?.geometry;
  let coordinates: number[] = []
  if (geometry?.type === 'Point') {
      coordinates = (geometry as Point).coordinates;
  }

  // カードのスタイル変更
  const changeStyle = () => {
    if (feature.properties?.eventId === currentFeature?.properties?.eventId) {
      // クリック対象
      return { border: '1px solid green', backgroundColor: '#D6FFD6'};
    } else {
      // クリック対象外
      return { border: '1px solid #8d8d8d', backgroundColor: '#fff'};
    }
  }

  // カードをクリックした時
  const onClickCard = () => {
    if (event.category === 0) {
      const link = document.createElement("a");
      link.href = event.url ?? "about:blank"; // `undefined` の場合は空ページを設定
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      
      // スマホ対策: `document.body.appendChild()` してから `click()` を実行
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // 使用後に削除
    } else {
      clickCard(feature);
    }
  };

  // タイトル
  let title = event.title;
  if (title.length > TITLE_MAX_LENGTH) {
    title = event.title.substring(0, TITLE_MAX_LENGTH) + '...';
  }

  // サブタイトル
  let subTitle = Utils.eventDateString(event.startDate, event.endDate);
  if (event.category === 0) {
    subTitle = event.description.substring(0, SUB_TITLE_MAX_LENGTH) + '...';
  }
  
  const image = `${config.imageUrl}${event?.image}.png`;
  return (
    <Card 
      className="event-card" 
      id="event-card"
      style={changeStyle()}
      sx={{ maxWidth: 270 }}
    >
      <CardActionArea
        onClick={onClickCard}
        id={`card${event.eventId}`}
      >
        {/* イベントスキーマ */}
        <EventSchema
          config={config}
          event={event}
          coordinates={coordinates}
        />
        <CardHeader
          title={title}
          subheader={subTitle}
          sx={{
              padding: "10px 5px 2px 5px",
              "& .MuiCardHeader-subheader": {
                fontSize: "14px", // 文字サイズを調整
              },
            }}
        />
        <CardMedia
          component="img"
          height="140"
          image={image}
          alt={event.title}
        />
      </CardActionArea>
    </Card>
  );
}

export default MapEventCard;